import React from 'react';
import GraphView from '../../GraphView';

const getTimeseriesOptions = ({ ratingCurveData, graphSettings, onGraphSelect }) => {
  const { useLog } = graphSettings;
  return {
    chart: {
      zoomType: 'x',
      type: 'line',
      events: {
        selection: onGraphSelect,
      },
    },
    title: {
      text: '',
    },
    tooltip: {
      shared: true
    },
    plotOptions: {
      series: {
        animation: false,
      }
    },
    xAxis: {
      type: 'datetime',
    },
    yAxis: [{
      title: {
        text: 'm',
      },
      startOnTick: false,
      endOnTick: false
    }, {
      title: {
        text: 'm3/s',
      },
      opposite: true,
      startOnTick: false,
      endOnTick: false
    }],
    series: [
      {
        name: 'Water Level',
        data: ratingCurveData.timeSeries.stage[useLog ? 'log' : 'normal'],
        yAxis: 0
      },
      {
        name: 'Observed Discharge',
        data: ratingCurveData.timeSeries.q[useLog ? 'log' : 'normal'],
        yAxis: 1
      },
      {
        name: 'Generated Discharge',
        data: ratingCurveData.timeSeries.gen_q[useLog ? 'log' : 'normal'],
        yAxis: 1
      },
    ]
  }
}

const getRatingCurveOptions = ({ ratingCurveData, graphSettings, onMouseOver, series_type, onGraphSelect }) => {
  const { useLog, toggleAxis } = graphSettings;
  let observedDischargeSeries = ratingCurveData.observedDischarge[useLog ? 'logSeries' : 'normalSeries'];
  let ratingCurveSeries = ratingCurveData.ratingEquation[useLog ? 'logSeries' : 'normalSeries'];

  let stageAxisTitle = useLog ? `ln(WL - h0)` : 'WL - h0',
    dischargeAxisTitle = useLog ? 'ln(Q)' : 'Q';

  return {
    chart: {
      zoomType: 'x',
      events: {
        selection: onGraphSelect,
      },
    },
    title: {
      text: '',
    },
    tooltip: {
      shared: true
    },
    plotOptions: {
      series: {
        animation: false,
        point: {
          events: {
            mouseOver: function () {
              if(toggleAxis) onMouseOver(this.x, this.y)
              else onMouseOver(this.y, this.x);
            }
          }
        }
      }
    },
    yAxis: {
      // min:-3, max:3,
      title: {
        text: toggleAxis ? dischargeAxisTitle : stageAxisTitle,
      },
    },
    xAxis: {
      title: {
        text: toggleAxis ? stageAxisTitle : dischargeAxisTitle,
      },
    },
    series: [
      {
        name: 'Observed',
        type: 'scatter',
        data: observedDischargeSeries.map(item => (toggleAxis ? [item[0], item[1]] : [item[1], item[0]])),
      },
      // {
      //   name: 'Derived',
      //   type: 'scatter',
      //   data: observedDischargeSeries.map(item => [item[0], ratingCurveSeriesMap[item[0]]]),
      // },
      {
        name: 'Rating Curve',
        type: 'line',
        data: ratingCurveSeries.map(item => (toggleAxis ? [item[0], item[1]] : [item[1], item[0]])),
      }
    ],
  };
}

function RTGraph(props) {
  let options = props.graphSettings.useTimeSeries ? getTimeseriesOptions(props) : getRatingCurveOptions(props);
  return <GraphView options={options} />;
}

export default RTGraph;


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/RTGraph2.js